export const contactEs = {
  contact: {
    title: "Contacto",
    contactLink: "Contáctanos",
  },
};
export const contactEn = {
  contact: {
    title: "Contact",
    contactLink: "Contact us",
  },
};
